import { PropsWithChildren, useRef, useState } from 'react';
import classNames from 'classnames';

import { StyledComponent } from 'types';

import { conciergeVideoThumbnail, conciergeVideoURL } from './consts';

import { CloudinaryImageProps } from '../CloudinaryImage';
import { VideoPlayer } from '../VideoPlayer';
import { PlayIcon } from '../VideoPlayer/PlayIcon';

type ConciergeVideoProps = StyledComponent & PropsWithChildren;

const videoThumbnail: CloudinaryImageProps = {
  src: conciergeVideoThumbnail,
  alt: 'Bezel Concierge Video Desktop Thumbnail',
  style: { width: '100%', height: '100%' },
  width: 0,
  height: 0,
  sizes: '100vw',
  priority: true,
  overrideTransformations: ['f_webp', 'dpr_2.0', 'q_100']
};

export const ConciergeVideo: React.FC<ConciergeVideoProps> = ({ className, children }) => {
  const [videoPlaying, setVideoPlaying] = useState<boolean>(false);
  const videoRef = useRef<HTMLDivElement>(null);

  const onClickVideo = () => {
    // Simulate click event to force unload the video thumbnail and load the video
    const previewElement = videoRef.current?.querySelector('.react-player__preview') as HTMLElement;

    if (previewElement) {
      previewElement.click();
    }
    setVideoPlaying(!videoPlaying);
  };

  const onEndVideo = () => {
    setVideoPlaying(false); // Set video back to starting phase when it ends
  };

  return (
    <div onClick={onClickVideo} className={classNames('position-relative', className)} ref={videoRef}>
      <VideoPlayer
        fitContainer
        playsinline
        playIcon={<></>}
        onEnded={onEndVideo}
        controls={false}
        url={conciergeVideoURL}
        thumbnail={videoThumbnail}
        playing={videoPlaying}
      />
      {children}
      <PlayIcon opacity={videoPlaying ? 0 : 0.9} blur={videoPlaying ? 0 : 3} size={55} playing={videoPlaying} />
    </div>
  );
};
